<script setup>
import money from '@/utilities/money.js'

defineProps({
  order: {
    type: Object,
    required: true
  }
})
</script>

<template>
  <div class="card p-3">
    <div class="container">
      <div class="row bg-light-lighten mb-2 py-1">
        <div class="col">
          <strong>{{ $t('views.retailer.applications.components.summary.product') }}</strong>
        </div>
        <div class="col-5 text-center">
          <strong>{{ $t('views.retailer.applications.components.summary.amount') }}</strong>
        </div>
        <div class="col text-end fw-semibold">
          {{ $t('views.retailer.applications.components.summary.price') }}
        </div>
      </div>
      <div class="row justify-content-end mb-2" v-for="item in order.items" :key="item.id">
        <div class="col p-1">{{ item.product.name }} ({{ item.brand ? item.brand.name : '-' }})</div>
        <div class="col-5 text-center">
          {{ item.quantity }}
          {{ item.product_unit.unit_name_with_rate_to_base_unit }} x
          {{ money.ofMinor(item.forward_unit_price).getFormattedAmount() }}
        </div>
        <div class="col text-end fw-semibold py-1">
          {{ money.ofMinor(item.forward_price).getFormattedAmount() }}
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-8 offset-4 rounded">
          <div class="d-flex justify-content-between fw-semibold">
            <span>{{ $t('views.retailer.applications.components.summary.total_forward_amount') }}</span>
            <span>{{ money.ofMinor(order.forward_price).getFormattedAmount() }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
